import CustomList from "../Util/List/CustomList/CustomList";
import CustomListContainer from "../Util/List/CustomList/CustomListContainer";
import config from "../../../../application/config/config";

function List() {
  const pathFrontEnd = '/core/dbmigrationslogs/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointDelete: `${config.endpoints.backend}core/dbmigrationslogs/delete`,
    endpoint: config.endpoints.backend + 'core/dbmigrationslogs/getall'
  }

  const formPaths = {
    urlGoBack: pathFrontEnd + 'list',
    pathView: pathFrontEnd + 'view',
    endpointGetById: config.endpoints.backend + 'core/dbmigrationslogs/getById',
  };

  const form = {
    containerType: 'dialog',
    validateOnChange: true,
    labelTitleView: 'Visualizar Log',
    fields: [
      {
        name: 'file',
        type: 'text',
        label: 'Arquivo',
        validations: {
          required: true
        },
        columnSize: 12
      },
      {
        name: 'from',
        type: 'text',
        label: 'Origem',
        validations: {
          required: true
        },
        columnSize: 12
      },
      {
        name: 'log',
        type: 'textarea',
        label: 'Log',
        validations: {
          required: true
        },
        columnSize: 12
      },

    ],
    ...formPaths,
  }

  let list = {
    labelTitle: "Lista de Migrations - Logs de Erro",
    fieldsShowOnDelete: [""],
    showPrintButtons: true,
    canAdd: false,
    canEdit: false,
    canView: true,
    canDelete: false,
    type: 'dialog',
    columns: [
      {
        name: "file",
        label: "Arquivo"
      },
      {
        name: "from",
        label: "Origem"
      },
      {
        name: "dtcreated",
        label: "Data"
      }
    ]
  };

  list = { ...list, ...paths }

  list.form = form

  return (
    <div>
      <CustomListContainer
        canAdd={list.canAdd}
        form={form}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        content={<CustomList list={list} />}
      />
    </div>
  );
}
export default List;